<template>
  <div class="players">
    <!-- <div class="left">
      <div class="menu" v-for="(item, index) in sortMenu" :key="index" @click="handle(index)">
        <div class="menuCell" :class="selectedIndex == index ? 'selMenuCell' : ''">
          <span>{{item}}</span>
        </div>
      </div>
    </div> -->
    <div class="right">
      <!-- <playersTable :playerList="playerList" :sectionTitle="sortMenu[index]" :tableID="tableIds[index]" v-for="(playerList, index) in dataList" :key="index"></playersTable> -->
      <playersTable :playerList="dataList[index]" :sectionTitle="sortMenu[index]" :tableID="tableIds[index]" v-for="(playerList, index) in dataList" :key="index"/>
    </div>
    <loadStateView :state="netState" :refreshHandle="refreshData"/>
  </div>
</template>

<script>
import playersTable from '../components/playersTable'

export default {
  components: {
    playersTable
  },
  activated () {
    if (this.$route.params.yearForRoute && this.$route.params.yearForRoute.length > 0) {
      this.year = this.$route.params.yearForRoute
    } else {
      this.loadData()
    }
  },
  watch: {
    year (newValue) {
      if (newValue.length > 0) {
        this.loadDataWithYear()
      } else {
        this.loadData()
      }
    }
  },
  props: {
    yearForRoute: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      sortMenu: [
        this.$t('players.shooters')
      ],
      tableIds: [
        'shooters',
        'owns',
        'yellowCards',
        'redCards'
      ],
      dataList: [],
      selectedIndex: 0,
      year: this.yearForRoute,
      netState: 0
    }
  },
  methods: {
    loadData: function () {
      this.netState = this.dataList.length > 0 ? 0 : 1
      this.$ft_getLeagueShooter(this.$route.params.leagueId).then(result => {
        this.computedData(result)
      }).catch((error) => {
        this.netState = this.groupList.length > 0 ? 0 : 2
        console.log('error:', error)
      })
    },
    loadDataWithYear: function () {
      this.netState = this.dataList.length > 0 ? 0 : 1
      this.$ft_getShooterByYear(this.$route.params.leagueId, this.year).then(result => {
        this.computedData(result)
      }).catch((error) => {
        this.netState = this.dataList.length > 0 ? 0 : 2
        console.log('error:', error)
      })
    },
    refreshData: function () {
      if (this.year.length > 0) {
        this.loadDataWithYear()
      } else {
        this.loadData()
      }
    },
    computedData: function (result) {
      if (result.netState === 2) {
        this.netState = result.netState
        return
      }
      var dataList = []
      if (result.hasOwnProperty('shooters')) {
        dataList.push(result.shooters)
      }
      // dataList.push(result.ownGoal)
      // dataList.push(result.yellowCard)
      // dataList.push(result.redCard)
      this.dataList = dataList
      this.netState = this.dataList.length > 0 ? 0 : 3
    },
    handle: function (index) {
      this.selectedIndex = index
      this.goAnchor('#' + this.tableIds[index])
    },
    goAnchor: function (selector) {
      document.querySelector(selector).scrollIntoView(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "style"
</style>
